import { format } from 'date-fns';
import { Calendar as CalendarIcon } from 'lucide-react';

import { Popover, PopoverContent, PopoverTrigger } from '../ui/Popover';
import { Button } from '../ui/Button';
import { Calendar } from '../ui/Calendar';
import { cn } from '@/lib/utils';
import { DateRange } from 'react-day-picker';
import { useState } from 'react';
import { PopoverClose } from '@radix-ui/react-popover';
import Flex from '../ui/Flex';

type DateRangePickerProps = {
  onClosed: (dateRange?: DateRange) => void;
};

const defaultDateRange: DateRange = {
  from: new Date(new Date().setMonth(new Date().getMonth() - 1)),
  to: new Date(),
};

export default function DateRangePicker({ onClosed }: DateRangePickerProps) {
  const [dateRange, setDateRange] = useState<DateRange | undefined>(
    defaultDateRange
  );

  return (
    <Popover
      onOpenChange={(isOpen) => {
        if (!isOpen) onClosed(dateRange);
      }}
    >
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            'w-full sm:w-[240px] justify-start text-left font-normal',
            !dateRange && 'text-muted-foreground'
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {dateRange && dateRange.from ? (
            format(dateRange.from, 'P')
          ) : (
            <span>Pick a date</span>
          )}
          {dateRange && dateRange.to && ` - ${format(dateRange.to, 'P')}`}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-1">
        <Flex.Col>
          <Calendar
            mode="range"
            selected={dateRange}
            onSelect={setDateRange}
            initialFocus
          />
          <Flex.Col className="gap-1">
            <PopoverClose asChild>
              <Button variant={'default'}>Set date range</Button>
            </PopoverClose>
            <Button variant={'outline'} onClick={() => setDateRange(undefined)}>
              Reset
            </Button>
          </Flex.Col>
        </Flex.Col>
      </PopoverContent>
    </Popover>
  );
}
